import ImageIcon from "@mui/icons-material/Image";
import HorizontalRuleIcon from "@mui/icons-material/HorizontalRule";
import Crop75Icon from "@mui/icons-material/Crop75";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import Looks3Icon from "@mui/icons-material/Looks3";

export const stationeryObjectCodes: Array<{
  label: string;
  value: number;
  Icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  type?: string;
}> = [
  { label: "box", value: 6, Icon: Crop75Icon },
  { label: "line", value: 7, Icon: HorizontalRuleIcon },
  { label: "image", value: 8, Icon: ImageIcon },
  { label: "checkbox", value: 9, Icon: CheckBoxIcon, type: "checkbox" },
  { label: "text", value: 10, Icon: TextFieldsIcon, type: "text" },
  { label: "textarea", value: 15, Icon: TextSnippetIcon, type: "text" },
  { label: "number", value: 11, Icon: Looks3Icon, type: "text" },
  { label: "date", value: 12, Icon: CalendarMonthIcon, type: "date" },
];

export const lineExcludeInput = [
  "PREPAR",
  "SUFPAR",
  "TXTPAR",
  "IMGPAR",
  "PADPAR",
  "FONPAR",
  "ALIPAR",
  "PROPAR",
  "REDPAR",
  "SIZPAR",
  "VALPAR",
  "COLPAR",
  "CFOPAR",
];

export const boxExcludeInput = ["PREPAR", "SUFPAR", "IMGPAR", "PROPAR"];

export const imageExcludeInput = [
  "PREPAR",
  "SUFPAR",
  "FONPAR",
  "SIZPAR",
  "ALIPAR",
  "VALPAR",
  "BOLPAR",
  "ITAPAR",
  "COLPAR",
  "CFOPAR",
];

export const inputExcludeInput = [
  "PREPAR",
  "SUFPAR",
  "TXTPAR",
  "IMGPAR",
  "PROPAR",
];
